import type { Options as FocusTrapOptions } from 'focus-trap';
import type { KeyboardEventHandler, PropsWithChildren } from 'react';
import React, { Component } from 'react';

import FocusTrap from './focus-trap-react.js';

interface FocusManagerProps {
  focusTrapOptions?: FocusTrapOptions;
  onKeyDown?: KeyboardEventHandler;
  jsdomMode?: boolean;
  active?: boolean;
  preventScroll?: boolean;
}

export class FocusManager extends Component<PropsWithChildren<FocusManagerProps>> {
  static defaultProps = {
    focusTrapOptions: {
      clickOutsideDeactivates: true,
    },
    jsdomMode: false,
  };

  id: string;

  constructor(props: FocusManagerProps) {
    super(props);
    this.id = `fm_${Math.floor(Math.random() * 9999)}`;
    this.onActivate = this.onActivate.bind(this);
    this.onDeactivate = this.onDeactivate.bind(this);
  }

  onActivate() {}

  onDeactivate() {}

  render() {
    const { children, focusTrapOptions, jsdomMode, preventScroll, ...rest } = this.props;
    const options = {
      ...focusTrapOptions,
      onActivate: this.onActivate,
      onDeactivate: this.onDeactivate,
      clickOutsideDeactivates: true,
    };
    if (jsdomMode) {
      return <div {...rest}>{children}</div>;
    } else {
      return (
        <FocusTrap focusTrapOptions={{ ...options, preventScroll }} {...rest}>
          {children}
        </FocusTrap>
      );
    }
  }
}
